<template>
  <div class="row_center_between summary_section">
    <div class="row_center_start" style="height: 100%; flex-grow: 1" v-if="!isOrderConfirm">
      <text>共{{ getCartQuantity }}項，小計</text>
      <text style="font-size: 24px; color: #FD5001; margin-left: 5px;">${{ cartTotalPrice }}</text>
    </div>
    <button class="button" style="width: 110px" v-if="isOrdering"
      @click="toOrderConfirm">下一步</button>
    <button @click="back" v-if="isOrderConfirm && !loading" class="button" style="width: 110px; height: 50px; background-color: #06c755;">繼續選購</button>
    <el-button class="button" style="width: 110px; height: 50px;" :loading="loading" v-if="loading"></el-button>
    <!--
    <button class="button" style="width: 110px" v-if="isOrderConfirm && !loading"
      @click="showSelectPaymentType">結帳</button>
    -->
    <button class="button" style="width: 150px" v-if="isOrderConfirm && !loading"
      @click="showSelectPaymentType">選擇支付方式</button>
  </div>
</template>
<script>
import commonUtilities from '@/utils/common.utils';
import { mapGetters } from 'vuex';
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters('cart', {
      getCartQuantity: 'cartQuantity',
      cartTotalPrice: 'cartTotalPrice',
    }),
    getUrlParameters() {
      return this.$route.params
    },
    isOrderConfirm() {
      return this.getUrlParameters.process === 'orderConfirm'
    },
    isOrdering() {
      return this.getUrlParameters.process === 'ordering'
    },
  },
  methods: {
    toOrderConfirm() {
      if (this.getCartQuantity === 0) {
        commonUtilities.createToast('warning', '請先加入商品')
        return
      }
      this.$emit("toOrderConfirm")
    },
    showSelectPaymentType() {
      this.$emit("showSelectPaymentType")
    },
    back() {
      this.$emit("back")
    }
  },
};
</script>
<style lang="scss">
.summary_section {
  width: 100%;
  height: calc(env(safe-area-inset-bottom) + 70px);
  padding: 10px 2vw calc(env(safe-area-inset-bottom) + 10px);
  background-color: #f0f0f0;
  box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.2);
  color: #000;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFang SC;
  z-index: 10;
  flex-shrink: 0;
}
</style>
